export enum ContractsMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_CONTRACTS = 'SET_CONTRACTS'
}
